import type { Module } from '@/modules/companies/consts'
import React from 'react'
import styled from 'styled-components'
import { useModuleConfig } from '@/utils/hooks'
import { OptionToggle } from './OptionToggle'

const Wrapper = styled.div`
  & > div + div {
    margin-top: 2rem;
  }
`

export const ModuleOptionCards: React.JSX.CFC<{ module: Module }> = ({
  module,
}) => {
  const { moduleOptions } = useModuleConfig(module)

  return (
    <Wrapper>
      {moduleOptions.map(option => (
        <OptionToggle key={option.id} option={option} />
      ))}
    </Wrapper>
  )
}
